<template>
  <div class="roles-list">
    <v-banner color="error" dark v-if="fetchError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all <strong>roles</strong>. You can add, edit or delete roles. </span>
        <span>Roles are <strong>front application roles</strong>. It defines the rights on front application. When binding with scopes, roles can <strong>give access to users (through groups) to API permissions</strong>. </span>
        <span>As Roles are displayed to users, please be sure to <strong>explain roles purposes in the description and to have human readable and understandable name</strong>.</span>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <RolesTable
        v-on:refresh="fetchAll"
        v-on:createNew="openRoleCreationDialog"
        v-on:editRole="updateRole"
        v-on:deleteRole="openRoleDeletionDialog"
      />
      <RoleCreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createRole"
        ref="creationDialog"
      />
      <RoleDeletionDialog
        :dialog="deletionDialog"
        :role="selectedRole"
        v-on:cancel="deletionDialog = false"
        v-on:deleteRole="deleteRole"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import mixin from "@/mixins";
import RolesTable from "@/components/Admin/Roles/RolesTable";
import RoleCreationDialog from "@/components/Admin/Roles/RoleCreationDialog";
import RoleDeletionDialog from "@/components/Admin/Roles/RoleDeletionDialog";

export default {
  name: "RolesList",
  components: {
    RolesTable,
    RoleCreationDialog,
    RoleDeletionDialog
  },
  mixins: [mixin],
  data() {
    return {
      creationDialog: false,
      deletionDialog: false,
      selectedRole: {},
      snackbar: false,
      errorMessage: "",
      displayInfo: false,
    };
  },
  computed: {
    ...mapState({
      fetchError: state => state.roles.fetchAll.error
    })
  },
  methods: {
    ...mapActions("roles", { fetchAll: "fetchAll" }),
    ...mapActions("roles", { createOne: "createOne" }),
    ...mapActions("roles", { updateOne: "updateOne" }),
    ...mapActions("roles", { deleteOne: "deleteOne" }),
    openRoleCreationDialog() {
      this.creationDialog = true;
    },
    openRoleDeletionDialog(role) {
      this.selectedRole = role;
      this.deletionDialog = true;
    },
    createRole(name, description) {
      this.createOne({ name: name, description: description })
        .then(() => {
          this.fetchAll();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteRole(uuid) {
      this.deleteOne({ roleUuid: uuid })
        .then(() => {
          this.fetchAll();
          this.deletionDialog = false;
          this.selectedRole = {};
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    updateRole(roleUuid, roleName, roleDescription) {
      this.updateOne({
        roleUuid: roleUuid,
        name: roleName,
        description: roleDescription
      })
        .then(() => {
          this.fetchAll();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>